export default "__VITE_ASSET__b351a6fa__"